import React from 'react';
import './styles/NewsSection.css';
import { Fire, Right, Time } from '@icon-park/react';

function NewsSection() {
  const newsItems = [
    {
      badge: '热点',
      badgeColor: 'hot',
      title: '什么是食品"二维码标签"',
      date: '2023-06-15',
      description: '二维码标签通过对各种信息元素的编码，生成相应的二维码标识，让消费者能够快速获取食品详细信息...',
      readTime: '3分钟'
    },
    {
      badge: '今日活动',
      badgeColor: 'active',
      title: '2025全球食品科技创新大会即将召开',
      date: '2025-03-20',
      description: '大会将聚焦食品行业数字化转型，邀请行业专家共同探讨数字标签技术的未来发展...',
      readTime: '5分钟'
    },
    {
      badge: '最新',
      badgeColor: 'new',
      title: '食品企业如何实现数字标签升级',
      date: '2025-10-10',
      description: '从传统标签到数字标签的转型指南，帮助企业快速掌握数字标签生成与管理技能...',
      readTime: '4分钟'
    }
  ];

  const caseStudies = [
    { 
      name: '乳制品行业应用案例', 
      category: '乳制品',
      count: '120+'
    },
    { 
      name: '饮料行业数字标签解决方案', 
      category: '饮料',
      count: '85+'
    },
    { 
      name: '休闲零食产品标签案例', 
      category: '零食',
      count: '200+'
    },
    { 
      name: '保健食品标签管理实践', 
      category: '保健品',
      count: '65+'
    }
  ];

  return (
    <section className="news-section">
      <div className="container">
        {/* 标题 */}
        <div className="section-header">
          <h2 className="section-title">资讯与案例</h2>
          <p className="section-description">
            了解行业动态，借鉴成功经验
          </p>
        </div>

        <div className="news-container">
          {/* 左侧：资讯动态 */}
          <div className="news-column">
            <div className="column-header">
              <Fire theme="filled" size={24} fill="#FF6B35" />
              <h3 className="column-title">行业资讯</h3>
            </div>
            
            <div className="news-list">
              {newsItems.map((news, index) => (
                <div key={index} className="news-item" style={{ animationDelay: `${index * 0.1}s` }}>
                  <span className={`news-badge ${news.badgeColor}`}>{news.badge}</span>
                  
                  <div className="news-content">
                    <h4 className="news-title">{news.title}</h4>
                    <p className="news-description">{news.description}</p>
                    
                    <div className="news-meta">
                      <span className="news-date">
                        <Time theme="outline" size={14} fill="#64748b" strokeWidth={3} />
                        {news.date}
                      </span>
                      <span className="news-read-time">{news.readTime}阅读</span>
                    </div>
                  </div>

                  <button className="news-arrow">
                    <Right theme="outline" size={20} fill="#2563EB" strokeWidth={3} />
                  </button>
                </div>
              ))}
            </div>

            <button className="view-more-btn">查看全部资讯 →</button>
          </div>
          
          {/* 右侧：标签案例 */}
          <div className="case-column">
            <div className="column-header">
              <h3 className="column-title">成功案例</h3>
              <span className="case-count">500+ 案例</span>
            </div>
            
            <div className="case-list">
              {caseStudies.map((item, index) => (
                <div key={index} className="case-item" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="case-info">
                    <div className="case-name">{item.name}</div>
                    <div className="case-footer">
                      <span className="case-category">{item.category}</span>
                      <span className="case-count-badge">{item.count} 案例</span>
                    </div>
                  </div>
                  <button className="case-arrow">
                    <Right theme="outline" size={18} fill="#2563EB" strokeWidth={3} />
                  </button>
                </div>
              ))}
            </div>

            <button className="view-more-btn secondary">浏览更多案例 →</button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewsSection;
